import styled from "styled-components"

const Container = styled.div`
  font-size: clamp(0.5rem, 0.45rem + 0.25vw, 0.75rem);
  line-height: 160%;
  margin-block-end: clamp(2rem, 1.7rem + 1.5vw, 3.5rem);
  width: 100%;
`
const Span = styled.span`
  display: block;
`

const Disclaimers = ({ textList }: { textList: string[] }) => {
  return (
    <Container>
      {textList.map((text) => (
        <Span key={text}>{text}</Span>
      ))}
    </Container>
  )
}

export { Disclaimers }
